import { validateRecipientClientBusiness } from '../utils/validateRecipientClientBusiness';
export const reviewerToContactKey = (reviewer)=>{
    var _reviewer_email;
    return ((_reviewer_email = reviewer.email) !== null && _reviewer_email !== void 0 ? _reviewer_email : '').toLowerCase();
};
export const contactToReviewer = (contact, isSignatory)=>({
        firstName: contact.firstName(),
        lastName: contact.lastName(),
        email: contact.email(),
        isSignatory,
        clientContactId: contact.id()
    });
export const filterEligibleContacts = (param)=>{
    let { contacts, primary, excludeEmails } = param;
    return contacts.filter((c)=>{
        if (c.id() === primary.id()) return false;
        if (excludeEmails.has(c.email().toLowerCase())) return false;
        if (c.isSample()) return false;
        return validateRecipientClientBusiness({
            primary,
            recipient: c
        }).valid;
    });
};
